import React, { useState, useEffect } from 'react';

import { ValueInputs, ModalFilter } from '../../../../types';
import NotesFilters from '../notesFilters';

interface Props {
  requireTags?: boolean;
  inputEl?: any;
  values: ValueInputs;
  marketFilters?: ModalFilter | null;
  retailerFilters?: ModalFilter | null;
  metricFilters?: ModalFilter | null;
  onChange: (values: ValueInputs) => void;
  handleTextGrowth: (event: any) => void;
  tagsVisibility: boolean;
  isEditing: boolean;
  fetchingMetrics: boolean;
  gridWidth: number;
  setIsDropdownOpen?: (value: React.SetStateAction<boolean>) => void;
}

const Input = ({
  inputEl,
  values,
  marketFilters,
  retailerFilters,
  metricFilters,
  onChange,
  handleTextGrowth,
  requireTags,
  tagsVisibility,
  isEditing,
  fetchingMetrics,
  gridWidth,
  setIsDropdownOpen
}: Props): React.ReactElement => {
  const [inputActive, setInputActive] = useState<boolean>(false);
  const [selectedMarkets, setSelectedMarkets] = useState<number[] | null>(values.marketIds);
  const [selectedMetrics, setSelectedMetrics] = useState<number[] | null>(values.metricIds);
  const [selectedRetailer, setSelectedRetailer] = useState<number[] | null>(values.retailerIds);

  useEffect(() => {
    if (selectedMarkets || selectedMetrics || selectedRetailer) {
      onChange({
        input: values.input,
        marketIds: selectedMarkets,
        metricIds: selectedMetrics,
        retailerIds: selectedRetailer
      });
    }
  }, [values, selectedMarkets, selectedMetrics, selectedRetailer]);

  return (
    <div
      className={`border border-borderGray rounded ${gridWidth > 800 ? 'w-full' : 'min-w-[550px]'} ${
        inputActive ? 'border-navy' : 'border-borderGray'
      }`}
      ref={inputEl}
    >
      <textarea
        className="border-0 box-border w-full resize-none font-nunitoLight text-sm pt-[11px] px-4 pb-0 leading-[21px]"
        onFocus={() => setInputActive(true)}
        onBlur={() => setInputActive(false)}
        value={values.input}
        onChange={(e) => {
          onChange({
            input: e.target.value,
            marketIds: values.marketIds,
            metricIds: values.metricIds,
            retailerIds: values.retailerIds
          });
        }}
        placeholder="Post a message (500 character limit)"
        onKeyDown={handleTextGrowth}
      />
      <div className="bg-[#f3f3f3] flex items-center box-border p-2">
        {requireTags && (
          <span className="text-[#727272] font-nunitoMedium my-0 mx-2.5 text-xs leading-[18px]">Required:</span>
        )}
        {/* for metric set variant = metric */}
        <NotesFilters
          dropup={true}
          marketFilters={marketFilters}
          metricFilters={metricFilters}
          retailerFilters={retailerFilters}
          setSelectedMarkets={setSelectedMarkets}
          setSelectedMetrics={setSelectedMetrics}
          setSelectedRetailer={setSelectedRetailer}
          tagsVisibility={tagsVisibility}
          isEditing={isEditing}
          values={values}
          fetchingMetrics={fetchingMetrics}
          gridWidth={gridWidth}
          setIsDropdownOpen={setIsDropdownOpen}
        />
      </div>
    </div>
  );
};

export default Input;
